// extracted by mini-css-extract-plugin
export default {"price":"jka-z","onSale":"kka-z","msrpLabelPrice":"lka-z","msrpLabel":"mka-z","originalPrice":"nka-z"};